import { DRAWER_CONTEXT_PREFIX } from 'tripPlanner/utils/askAIContextMarkers'

export const DRAWER_CONTEXT_TOOL_NOTE = 'Note: This context only includes a high level summary. More information can be found using tools when exact pricing, availability, booking, or offer details are needed.'

interface BuildDrawerAskAIContextMessageArgs {
  contextLabel: string
  contextDetails?: string
  contextNote?: string
}

export function compactLines(lines: Array<string | undefined | false>): string {
  return lines.filter(Boolean).join('\n')
}

export function buildDrawerAskAIContextMessage({
  contextLabel,
  contextDetails,
  contextNote,
}: BuildDrawerAskAIContextMessageArgs): string {
  const detailsPart = contextDetails ? `\n${contextDetails}` : ''
  const notePart = contextDetails
    ? `\n${contextNote ?? DRAWER_CONTEXT_TOOL_NOTE}`
    : ''

  return `${DRAWER_CONTEXT_PREFIX}${contextLabel}${detailsPart}${notePart}`
}
